import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuthContext } from './AuthContext.js';

/**
 * Schützt untergeordnete Routen. Ohne Token geht es zur Login-Seite, danach zurück zum
 * ursprünglich angeforderten Ziel — **inklusive Query-String und Fragment**. In Atleo war
 * genau das ein Bug: Der Wizard trug seine `draftId` im Query, und nach dem Login landete der
 * Nutzer auf einem leeren Entwurf.
 *
 * `loginPath` ist ein Parameter, weil Portal und Admin-App unterschiedliche Login-Routen haben.
 *
 * **Das ist eine Bequemlichkeit für die Oberfläche, kein Zugriffsschutz.** Der eigentliche
 * Check sitzt serverseitig in jedem Handler (`docs/02_DOMAIN_MODEL.md` §5).
 */
export function ProtectedRoute({ loginPath = '/login' }: { loginPath?: string }) {
  const { token, isAuthLoading } = useAuthContext();
  const location = useLocation();

  // Während des Ladens nichts rendern — sonst blitzt die Login-Seite kurz auf.
  if (isAuthLoading) return null;

  if (!token) {
    const target = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={`${loginPath}?redirect=${encodeURIComponent(target)}`} replace />;
  }

  return <Outlet />;
}
